export default {
  resample: { foobar: true },
};
